import React from "react"
import { collapseSideBar } from "context/applicationContext"
import SubHeader from "components/Shared/SubHeader"
import { tabs } from "../utils"
import * as paths from "constants/paths"

const SwitchingByProducts: React.FC = () => {
	collapseSideBar()

	return (
		<div className="customer-behavior-switching">
			<SubHeader
				tabs={tabs}
				parentPath={paths.CUSTOMER_BEHAVIOR}
				title={"phronesis.menu.option.customerbehavior.title"}
				subTitle={"phronesis.customerbehavior.application.switching"}
			/>
		</div>
	)
}

export default SwitchingByProducts
